<template>
  <div>
     <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="background: url('/static/img/newsletter.svg'); background-position: top !important;"
        ></div>
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">{{ $t("subscribe_to_our_newsletter") }}</div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div class="pt-8">
      <div class="row disablerow align-items-start">
        <!-- Left Area -->
        <div class="col-xl-9 innercreatetraining subscription_news">
          <!-- confirm unsubscription -->
          <!-- unsubscription -->
          <div class="sto_newsletter_popup">
            <img class="newsletter_v_arrow" src="/static/img/ev__close.png" />
            <h3 class="align_center">{{ $t("confirm_unsubscription") }}</h3>
            <p class="nl_p1">{{ $t("we_sorry") }}</p>
            <p class="nl_p1">
              {{ $t("you_are_about_to_unsubscribe") }}<br />
              {{ $t("if_you_wish_proceed_please_confirm") }}<br />
              {{ $t("email") }}: {{ subscriptionEmail }}
            </p>
            <v-card-actions class="">
              <v-btn
                @click="cancelSubscription"
                outlined
                depressed
                tile
                class="savebutton"
              >
                {{ $t("no_keep_me_subscribed") }}</v-btn
              >
              <v-btn
                @click="finalSubscrptionConfirmationUnsubscibe"
                outlined
                depressed
                tile
                class="cancelBtn"
              >
                {{ $t("yes_unsubscribe_me") }}</v-btn
              >
            </v-card-actions>
            <p class="nl_p2 mt-3">
              {{ $t("you_can_resubscribe_at_any_time") }} <br />  
              <span v-html="$t('have_any_questions', { email: '<a href=\'mailto:trainingacademy@knorr-bremse.com\'>trainingacademy@knorr-bremse.com</a>' })"></span>

            </p>
          </div>
        </div>

        <!-- Right Area -->
        <div class="col-xl-3 ml-1 px-0 pl-md-12 pl-lg-8 row pt-0 onlyContact">
          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      subscriptionId: null,
      subscriptionEmail: null,
    };
  },

  mounted() {
    this.subscriptionId = this.$route.query.subscriptionId;
    this.getSubscriptionData();
  },

  methods: {
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    onFinally() {
      showLoadingCircle(false);
    },
    cancelSubscription() {
      sessionStorage.removeItem("subscriptionData");
      this.$router.push("/categories");
    },
    getSubscriptionData() {
      var _this = this;
      this.$axios
        .get("api/newsletter/get-subscription/" + this.subscriptionId)
        .then(function (response) {
          _this.subscriptionEmail = response.data.subscriptionMail;
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    finalSubscrptionConfirmationUnsubscibe() {
      var _this = this;
      this.$axios
        .put("api/newsletter/" + this.subscriptionId + "/unsubscribe")
        .then(function (response) {
          _this.$router.push("/unsubscribe-success");
        })
        .catch(this.onError);
    },
  },
};
</script>
